import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-16",
  "use": "icon-button_icon-16-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-button_icon-16\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path d=\"M3 14a9 9 0 0018 0\" /><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 14V5.294L12 1l9 4.294v8.66\" /><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18 9l-6.919 7L7 11.87\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol